/* Real Judge.me values, presented like the reference badge. */
if (!customElements.get('woodlas-product-rating')) {
  customElements.define('woodlas-product-rating', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', event => this.openReviews(event), { capture: true, signal: this.controller.signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') this.openReviews(event);
      }, { capture: true, signal: this.controller.signal });
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.format());
      this.observer.observe(this, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['data-average-rating', 'data-number-of-reviews']
      });
      this.format();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
    format() {
      const badge = this.querySelector('.jdgm-prev-badge');
      const label = badge?.querySelector('.jdgm-prev-badge__text');
      const stars = badge?.querySelector('.jdgm-prev-badge__stars');
      const rating = Number(badge?.dataset.averageRating);
      const count = Number(badge?.dataset.numberOfReviews);
      if (!label || !Number.isFinite(rating) || !Number.isInteger(count) || count < 0) return;
      const text = count > 0 && rating > 0
        ? `${rating.toFixed(1)}/5 (${count} ${count === 1 ? 'review' : 'reviews'})`
        : 'No reviews yet';
      if (label.textContent !== text) label.textContent = text;
      this.setAttribute('aria-label', count > 0 ? `${rating.toFixed(1)} out of 5, ${count} ${count === 1 ? 'review' : 'reviews'}. Read customer reviews` : 'No reviews yet. See customer reviews');
      // One keyboard target for the complete review badge.
      stars?.removeAttribute('tabindex');
      stars?.setAttribute('role', 'img');
      stars?.setAttribute('aria-label', `${rating.toFixed(1)} out of 5 stars`);
    }
    openReviews(event) {
      const reviews = document.getElementById('judgeme_product_reviews');
      if (!reviews) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      reviews.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      const heading = reviews.querySelector('h2, h3') || reviews;
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
  });
}
